import { render } from "./banner.vue?vue&type=template&id=06d2c268"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=06d2c268&lang=scss"

import exportComponent from "F:\\webWork\\demo\\h5sdk2\\h5sdk3.muugame.com\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__